import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import TableLayout from "../../../components/TableLayout";
import TableActions from "../../../components/Common/TableActions";
import CustomPagination from "../../../components/Common/CustomPagination";
import Filter from "../../../components/Common/Filter";
import { Link, useLocation } from "react-router-dom";
import dataHandler from "../../../hooks/dataHandler";
import { ROOMDELETE, ROOMLIST } from "../../../services/ApiCalls";
import CountryFilter from "../../../components/Common/CountryFilter";
import { activeInactiveOptions } from "../../../utilities/const";
import ConfirmationPop from "../../../components/Modals/ConfirmationPop";
import { useTranslation } from "react-i18next";
import moment from "moment";

const ManageRoomList = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const {
    setBody,
    body,
    data,
    loader,
    deleteModel,
    setDeleteModel,
    paginationHandler,
    searchHandler,
    total,
    deleteHandler,
  } = dataHandler({
    api: ROOMLIST,
  });

  useEffect(() => {
    const queryPage = new URLSearchParams(location.search).get("page");

    if (queryPage) {
      setBody((p) => ({ ...p, page: Number(queryPage) }));
    }
  }, []);

  const column = [
    {
      head: t("manageRoom.columns.srNo"),
      accessor: "#",
      component: (item, key) => <>{key < 9 ? `0${key + 1}` : key + 1}</>,
    },
    {
      head: t("manageRoom.columns.hotelName"),
      accessor: "hotelName",
      component: (item) => <>{item?.hotelDetail?.hotelName}</>,
    },
    {
      head: t("manageRoom.columns.hotelId"),
      accessor: "hotelId",
      component: (item) => <>{item?.hotelDetail?.hotelId}</>,
    },
    {
      head: t("manageRoom.columns.roomNumber"),
      accessor: "roomNumber",
      component: (item) => <span className="d-flex justify-content-center align-items-center">{item.roomNumber}</span>,
    },
    {
      head: t("manageRoom.columns.roomType"),
      accessor: "roomType",
      component: (item) => (
        <span style={{ color: "#E8307A" }}>{item.roomType?.name || "-"}</span>
      ),
    },
    {
      head: t("manageRoom.columns.checkInTime"),
      accessor: "roomType",
      component: (item) => {
        const time = item?.checkInHour;
        if (!time && time !== 0)
          return <span style={{ color: "#E8307A" }}>--</span>;

        const formatted = moment(
          typeof time === "number" ? `${time}:00` : time,
          ["H:mm", "HH:mm", "HH:mm:ss", moment.ISO_8601],
          true
        ).format("h:mm A");

        return (
          <span className="d-flex justify-content-center align-items-center" style={{ color: "#E8307A" }}>
            {formatted === "Invalid date" ? "--" : formatted}
          </span>
        );
      },
    },
    {
      head: t("manageRoom.columns.basePrice"),
      accessor: "numberOfBed",
      component: (item) => (
        <span className="d-flex justify-content-center align-items-center" style={{ color: "#E8307A" }}>
          {item?.pricing?.[0]?.basePrice || "-"}
        </span>
      ),
    },

    {
      head: t("manageRoom.columns.floorNumber"),
      accessor: "floorNumber",
      component: (item) => <span className="d-flex justify-content-center align-items-center">{item.floorNumber || "-"}</span>,
    },
    {
      head: t("manageRoom.columns.numberOfBed"),
      accessor: "numberOfBed",
      component: (item) => <span className="d-flex justify-content-center align-items-center">{item.numberOfBed || "-"}</span>,
    },

    {
      head: t("manageRoom.columns.status"),
      accessor: "status",
      component: (item) => (
        <span
          className={`badge ${
            item.status === "Available" ? "bg-success" : "bg-secondary"
          }`}
        >
          {item.status}
        </span>
      ),
    },
    {
      head: t("manageRoom.columns.action"),
      accessor: "action",
      component: (item) => (
        <TableActions
          editUrl={`/room/edit/${item._id}?page=${body.page}`}
          viewLink={`/room/detail/${item._id}?page=${body.page}`}
          setDeleteModel={() =>
            setDeleteModel({ show: true, dumpId: item._id })
          }
        />
      ),
    },
  ];

  return (
    <>
      <ConfirmationPop
        type={"delete"}
        confirmation={deleteModel.show}
        setConfirmation={() =>
          setDeleteModel({
            show: false,
            dumpId: "",
          })
        }
        confirmHandler={() =>
          deleteHandler(() => ROOMDELETE({ _id: deleteModel.dumpId }))
        }
      />
      <section className="room-management py-3 position-relative">
        <Container>
          <Row>
            <Col lg="12">
              <div className="d-flex justify-content-between align-items-center">
                <h4 className="mb-0 py-3 fw-bold text-dark text-capitalize">
                  {t("manageRoom.title")}
                </h4>

                {/* <div className="d-flex align-items-center gap-2">
                  <label
                    htmlFor="countryFilter"
                    className="form-label m-0 fw-semibold text-muted"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    {t("manageRoom.filter")}
                  </label>
                  <CountryFilter
                    id="countryFilter"
                    body={body}
                    setBody={setBody}
                  />
                </div> */}
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-center justify-content-between flex-wrap gap-10 mb-3">
                <div className="left">
                  <Filter
                    body={body}
                    searchHandler={searchHandler}
                    setBody={setBody}
                    statusFilterOptionArr={activeInactiveOptions}
                  />
                </div>
                <div className="right d-flex gap-3">
                  <Link
                    to="/room/add"
                    className="d-flex btn btn-primary align-items-center justify-content-center fw-sbold commonBtn "
                    style={{ height: 40, minWidth: 100, fontSize: 12 }}
                  >
                    {t("manageRoom.addRoom")}
                  </Link>
                </div>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <TableLayout column={column} data={data} loader={loader} />
              <CustomPagination
                total={total}
                pageChangeHandler={paginationHandler}
                body={body}
                setBody={setBody}
              />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ManageRoomList;
